import { Window } from 'styles/Window';
import { useTitle } from 'hookrouter';

const About = () => {
  useTitle("About YTH");

  return (
    (
    <Window>
      <p className="pagetitle">About Me</p>
      <p>I recieved my PhD from the School of Creative Media (<a href="https://www.scm.cityu.edu.hk/">SCM</a>), City University of Hong Kong (<a href="https://www.cityu.edu.hk/">CityU</a>).</p>
      <p>I research video game cultures: in particular I am interested in how creators are re-releasing and remaking video games across time, with respect to changing technological and cultural conditions.</p>
      <p>I have dabbled in hardware and software development, including 3D printing, laser cutting, PCBs, making games with Unity/Godot, building websites, etc.</p>
      <p>I love technology, computers and video games and am interested in the intersections between them, science, philosophy and human culture.</p>
      <p>This website is one of my projects and is powered by React!</p>
      <p className="title">Brief History</p>
      <p>2011-2015: MSci Physics, Univeristy College London (<a href="http://www.hep.ucl.ac.uk/~jthomas/4thyearprojects-2014.html">Masters Project</a>)</p>
      <p>2017-2020: Project Assistant at Technologies for the Elderly and Disabled People by Youths (<a href="https://www.cityu.edu.hk/youthempathy/achievement/en/projectInfo_TEDY.html">TEDY</a>)</p>
      <p>2020: Research Assistant at the Laboratory for Interventions in Speculative Finance (<a href="https://www.scm.cityu.edu.hk/research/labs/laboratory-interventions-speculative-finance-lisf">LISF</a>)</p>
      <p>2021- 2026: PhD at SCM, CityU, Hong Kong PhD Fellowship recipient</p>
      <p className="title">Research Interests</p>
      <p>Video Game History and Cultures</p>
      <p>Creative Industries, Software, Infrasturctures, Technologies</p>
      <p>Worldbuilding</p>
      <p>Financial Art and Interventions: LISF lab member</p>
      <p className="title">Find Me</p>
      <a href = "https://www.linkedin.com/in/yiktungho">LinkedIn</a>
    </Window>
    )
  )
};

export default About;
